export default "__VITE_ASSET__CwbB9wsf__"